// extracted by mini-css-extract-plugin
export default {"tabContent":"uqgh3","tabContentActive":"_2ITLr"};